import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { livrosService, type DadosLivro, type Livro } from "@/modules/biblioteca/services/livrosService";

const QUERY_KEY_LIVROS = ["livros"];

export function useLivros() {
  return useQuery({
    queryKey: QUERY_KEY_LIVROS,
    queryFn: livrosService.listarTodos,
  });
}

export function useLivrosDisponiveis() {
  return useQuery({
    queryKey: [...QUERY_KEY_LIVROS, "disponiveis"],
    queryFn: livrosService.listarDisponiveis,
  });
}

export function useCatalogo() {
  return useQuery({
    queryKey: [...QUERY_KEY_LIVROS, "catalogo"],
    queryFn: livrosService.listarCatalogo,
  });
}

/** Maior número de cadastro já usado, para sugerir o próximo no formulário de novo livro. */
export function useMaiorNumeroCadastro(ativo: boolean) {
  return useQuery({
    queryKey: [...QUERY_KEY_LIVROS, "maior-numero-cadastro"],
    queryFn: livrosService.maiorNumeroCadastro,
    enabled: ativo,
    staleTime: 0,
  });
}

export function useCriarLivro() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dados: DadosLivro) => livrosService.criar(dados),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_LIVROS }),
  });
}

export function useAtualizarLivro() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dados, livroAtual }: { id: string; dados: DadosLivro; livroAtual: Livro }) =>
      livrosService.atualizar(id, dados, livroAtual),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_LIVROS }),
  });
}

export function useExcluirLivro() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => livrosService.excluir(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_LIVROS }),
  });
}
